import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslatedTitleResolver implements Resolve<string> {
  private translateService = inject(TranslateService);

  resolve(route: ActivatedRouteSnapshot): Promise<string> {
    const key = route.data.titleKey;
    if (!key) {
      return Promise.resolve('LiveFORMS.Web');
    }
    return firstValueFrom(this.translateService.get(key));
  }
}
